import _ from 'lodash';

/* @ngInject */
export default function DataUsageService($q, $sails, $log) {

  const service = this;

  service.getRcuUsage = getRcuUsage;
  service.getEquipmentUsage = getEquipmentUsage;
  service.getDailyUsage = getDailyUsage;
  service.getRecentUsage = getRecentUsageByEquipment;

  function sailsGet(url) {
    const baseUrl = '/equipmentdatausage';
    return $sails.get(`${baseUrl}/${url}`)
      .then(res => res.body);
  }

  function getRcuUsage() {
    return sailsGet('rcu/getUsageForDay/')
      .catch((error) => {
        $log.error('Could not get RCU Usage Data', error.data);
        return $q.reject(error.data);
      });
  }

  function getEquipmentUsage() {
    return sailsGet('equipment/getUsageForDay/')
      .catch((error) => {
        $log.error('Could not get Equipment Usage Data', error.data);
        return $q.reject(error.data);
      });
  }

  function getDailyUsage() {
    return sailsGet('getDailyUsage/')
      .catch((error) => {
        $log.error('Could not get Daily Usage', error.data);
        return $q.reject(error.data);
      });
  }

  /**
   * @param {Array<string>} equipment A list of equipment IDs
   * @returns {Promise<object>} Usage
   */
  function getRecentUsageByEquipment(equipment) {
    return _.isArray(equipment) ?
      sailsGet(`getRecentUsageByEquipment/${equipment.join('|')}`)
        .catch(({ data: error }) => {
          $log.error(error);
          return $q.reject(error);
        }) :
      $q.reject(new TypeError());
  }
}

